var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"noresult"},[_vm._m(0),_c('div',{staticClass:"noresult-title"},[_vm._v(_vm._s(_vm.$ml.with('VueJS').get('noResult')))]),_c('div',{staticClass:"noresult-text"},[_vm._v(_vm._s(_vm.$ml.with('VueJS').get('noResultTxt')))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-icon"},[_c('i',{staticClass:"icon icon-search"})])
}]

export { render, staticRenderFns }